<div class="favourites-settings">
  <div (click)="handleFavorites()" class="manage-favourites">
    <span>{{ "Manage Favorites" | translate }}</span>
    <mat-icon>settings</mat-icon>
  </div>
  <div class="favorites-wrapper">
    @for (item of favoriteItems; track item?.id) {
      <div class="parent">
        <a
          (click)="handleClick()"
          [routerLink]="[
            '/app/main',
            {
              outlets: {
                navigation: ['event', item?.id],
                content: ['event-markets', item?.id],
              },
            },
          ]"
          >{{ item?.name }}</a
        >
        <div class="children">
          @for (market of item.markets; track market?.id) {
            <a
              (click)="handleClick(market)"
              [routerLink]="[
                '/app/main',
                {
                  outlets: {
                    navigation: ['event', item?.id],
                    content: ['event-markets', item?.id, 'market', market?.id],
                  },
                },
              ]"
              class="child"
              >{{ market?.name }}</a
            >
          }
        </div>
      </div>
    }
  </div>
  @if (favoriteItems.length === 0) {
    <div class="no-favourites-info">
      <p>
        {{ "favorites_notice" | translate }}
      </p>
      <p>{{ "You do not have any Favorites" | translate }}</p>
    </div>
  }
</div>
